import React from 'react';
import {FaIcon} from "../FaIcon";
import {EditElementModal} from "../EditElementModal";
import {EditAvailableFundsForm} from "./EditAvailableFundsForm";

export class EditAvailableFundsModal extends EditElementModal {
    renderModalForm() {
        return <EditAvailableFundsForm closeModal={this.toggle}
                                       onModified={this.handleFormSubmitted}
                                       businessUnitId={this.props.businessUnitId}
                                       availableFunds={this.props.value}/>
    }

    renderButton() {
        return <button className="edit-button" onClick={this.toggle}><FaIcon iconName={"pencil-alt"}/></button>;
    }

    renderModalHeaderText() {
        return "Actualizar el saldo disponible";
    }
}
